module.exports = __webpack_public_path__ + "js/0.b5266043.worker.js"